import { PromptModal } from "_components/Abstractions/PromptModal";
import { useToast } from "_helpers/notifications/useToasts";
import { useDispatch } from "react-redux";
import { ratePlansActions } from "../../../../../_store/ratePlan.slice";

export function DeleteContractorRatePlan({ ratePlanId, contractorId }) {
  const dispatch = useDispatch();
  const { showSuccessMessage, showErrorMessage } = useToast();

  async function onSubmit() {
    const payload = { ratePlanId };
    const response = await dispatch(ratePlansActions.deleteRatePlan({ payload }));

    if (!response.error) {
      await dispatch(ratePlansActions.getRatePlans({ id: contractorId }));
      showSuccessMessage("Usunięto cennik");
    } else {
      showErrorMessage(response.error?.message);
    }
  }

  return (
    <>
      <PromptModal
        buttonText="Usuń cennik"
        btnSize="sm"
        btnTextSize="smaller"
        btnVariant="outline-danger"
        title={`Czy usunąć cennik?`}
        type="YesNo"
        onSubmit={onSubmit}
      />
    </>
  );
}

